import {
  InputAdornment,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import ShowRouteButton from "./ShowRouteButton";
import SearchIcon from "@material-ui/icons/Search";

interface IRouteList {
  routes: any;
  handleOpenRoutePanel: any;
  handleExistingMarkers: any;
  setRouteData: any;
}

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 440,
  },
  searchInput: {
    marginBottom: 10,
    float: "right",
    "& fieldset": {
      borderColor: "rgba(0, 0, 0, 0.13)",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(0, 0, 0, 0.13)",
    },
    "& .MuiOutlinedInput-root > .MuiOutlinedInput-input": {
      padding: "10px",
    },
    "& .MuiOutlinedInput-root > .MuiInputAdornment-root": {
      color: "rgba(0, 0, 0, 0.54)",
    },
  },
});

const RouteList = ({
  routes,
  handleOpenRoutePanel,
  handleExistingMarkers,
  setRouteData,
}: IRouteList) => {
  // override routes to set key index to object
  // because it's using for show the detail route
  routes.forEach((route: any, index: number) => (route.key = index));

  const [searchText, setSearchText] = useState<string>("");
  const [searchDatas, setSearchDatas] = useState<any>([]);
  const classes = useStyles();

  const TotalStudentField = ({ route }: { route: any }) => {
    let totalStudents = 0;

    route.routeLocations.forEach((routeLocation: any) => {
      totalStudents += routeLocation.students.length;
    });

    return <>{totalStudents}</>;
  };

  const TotalStopField = ({ route }: { route: any }) => {
    return <>{route.routeLocations.length}</>;
  };

  useEffect(() => {
    if (searchText !== "") {
      setSearchDatas(
        routes.filter((route: any) => route.name.includes(searchText))
      );
    }
  }, [searchText]);

  return (
    <Paper className={classes.root}>
      <TextField
        id="input-with-icon-textfield"
        className={classes.searchInput}
        variant="outlined"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        onInput={(e: any) => setSearchText(e.target.value)}
      />

      <TableContainer className={classes.container}>
        <Table stickyHeader size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>Route Name</TableCell>
              <TableCell align="right">Total Students</TableCell>
              <TableCell align="right">Total Stops</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(searchText !== "" ? searchDatas : routes).map((route: any) => (
              <TableRow key={`route-item-key-${route.id}`}>
                <TableCell component="th" scope="row">
                  {route.name}
                </TableCell>
                <TableCell align="right">
                  <TotalStudentField route={route} />
                </TableCell>
                <TableCell align="right">
                  <TotalStopField route={route} />
                </TableCell>
                <TableCell align="center">
                  <ShowRouteButton
                    route={route}
                    index={route.key}
                    handleOpenRoutePanel={handleOpenRoutePanel}
                    handleExistingMarkers={handleExistingMarkers}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default RouteList;
